module.exports = __webpack_public_path__ + "img/custom-item2-3.607879f.png";